import React from "react";
import Loading from "./Loading";

const PageLoading = () => {
  return (
    <div className="w-full h-full fixed bg-black flex justify-center items-center backdrop-blur-md bg-opacity-20 z-[9999999]">
      <div className="w-60 h-44 flex flex-col gap-5 bg-white rounded-xl justify-center items-center">
        <h2 className="text-xl text-[#2f52ef] font-black">هتل عروس</h2>

        <Loading />
        {/* <span className="line-loader"></span> */}
      </div>
    </div>
  );
};

export default PageLoading;
